import { createI18n } from "vue-i18n";
import { useI18nApi } from "../api/i18n";

let i18n;

export async function useI18n({ locale = "en", key, legacy = false }) {
  const api = useI18nApi();
  const messages = await api.all(key);

  i18n = createI18n({
    legacy,
    locale,
    messages: {
      [locale]: messages?.toJSON() ?? {},
    },
  });

  return { i18n };
}

export function useI18nInstance() {
  if (!i18n) {
    throw new Error("i18n instance not initialized");
  }
  return i18n.global;
}
